import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import DocumentList from '@/components/document-menu/document-list';
import PanelTitle from '@/components/document-menu/panels/panel-title';
import {Document} from '@/interfaces/document';

interface ElementProps {
  waitingSignature: Document[];
  waitingSubmit: Document[];
  closeMenu: () => void;
}

const PanelPending: FunctionComponent<ElementProps> = ({waitingSignature, waitingSubmit, closeMenu}) => {
  const {t} = useTranslation();

  return (
    <>
      <PanelTitle title={t('components.document-menu.panels.pending.waiting-signature.title')} />

      <DocumentList
        emptyResultMessage={t('components.document-menu.panels.pending.waiting-signature.no-result-message')}
        documents={waitingSignature}
        linksDisabled={true}
        onItemClick={closeMenu}
      />

      {waitingSubmit && waitingSubmit.length > 0 && (
        <>
          <hr className="mx-6 mb-8 mt-4 border-grey-450" />

          <PanelTitle title={t('components.document-menu.panels.pending.waiting-submit.title')} />

          <DocumentList
            emptyResultMessage={t('components.document-menu.panels.pending.waiting-submit.no-result-message')}
            documents={waitingSubmit}
            linksDisabled={true}
            onItemClick={closeMenu}
          />
        </>
      )}
    </>
  );
};

export default PanelPending;
